function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.055
    },
    fill: "#3a99f3",
    d: "M 119.5,204.5 C 121.641,203.837 123.975,203.503 126.5,203.5C 130.141,203.315 133.474,203.981 136.5,205.5C 132.19,204.92 127.857,204.586 123.5,204.5C 122.167,204.5 120.833,204.5 119.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a97f2",
    d: "M 136.5,205.5 C 137.791,205.263 138.791,205.596 139.5,206.5C 138.209,206.737 137.209,206.404 136.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a71e7",
    d: "M 119.5,204.5 C 120.833,204.5 122.167,204.5 123.5,204.5C 115.138,206.52 108.138,210.853 102.5,217.5C 103.754,214.907 105.42,212.573 107.5,210.5C 110.633,206.933 114.633,204.933 119.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d8bed",
    d: "M 139.5,206.5 C 141.674,206.75 143.341,207.75 144.5,209.5C 142.326,209.25 140.659,208.25 139.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b7ef5",
    d: "M 131.5,210.5 C 131.5,210.833 131.5,211.167 131.5,211.5C 127.833,211.5 124.167,211.5 120.5,211.5C 123.998,209.738 127.665,209.404 131.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#625ee5",
    d: "M 131.5,210.5 C 134.716,210.345 137.383,211.345 139.5,213.5C 137.883,212.962 136.216,212.629 134.5,212.5C 133.209,212.737 132.209,212.404 131.5,211.5C 131.5,211.167 131.5,210.833 131.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2da6f5",
    d: "M 107.5,210.5 C 105.42,212.573 103.754,214.907 102.5,217.5C 99.8352,219.835 98.5018,222.835 98.5,226.5C 98.7373,227.791 98.404,228.791 97.5,229.5C 96.5184,232.962 96.185,236.629 96.5,240.5C 94.492,231.177 96.3253,222.51 102,214.5C 103.451,212.536 105.284,211.203 107.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5180eb",
    d: "M 120.5,211.5 C 110.758,216.089 104.924,223.756 103,234.5C 102.56,222.102 108.393,214.435 120.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#6a44de",
    d: "M 102.5,217.5 C 101.403,220.686 100.07,223.686 98.5,226.5C 98.5018,222.835 99.8352,219.835 102.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.93
    },
    fill: "#2e3778",
    d: "M 133.5,229.5 C 127.481,222.748 121.815,223.081 116.5,230.5C 116.374,224.796 119.207,221.796 125,221.5C 130.333,221.669 133.166,224.336 133.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.082
    },
    fill: "#2454b6",
    d: "M 138.5,222.5 C 137.833,221.167 137.833,221.167 138.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#474fba",
    d: "M 187.5,229.5 C 194.508,229.334 201.508,229.5 208.5,230C 217.361,232.851 222.028,239.018 222.5,248.5C 222.456,257.776 218.123,263.942 209.5,267C 202.174,267.5 194.841,267.666 187.5,267.5C 187.5,254.833 187.5,242.167 187.5,229.5 Z M 195.5,235.5 C 210.862,233.906 216.695,240.573 213,255.5C 212.215,257.286 211.049,258.786 209.5,260C 205.018,261.796 200.351,262.63 195.5,262.5C 195.5,253.5 195.5,244.5 195.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#464fb9",
    d: "M 233.5,229.5 C 236.5,229.5 239.5,229.5 242.5,229.5C 246.888,242.608 251.555,255.608 256.5,268.5C 254.08,268.708 251.747,268.374 249.5,267.5C 247.881,264.812 246.547,261.979 245.5,259C 240.5,258.333 235.5,258.333 230.5,259C 229.307,261.887 227.973,264.72 226.5,267.5C 224.253,268.374 221.92,268.708 219.5,268.5C 224.167,255.5 228.833,242.5 233.5,229.5 Z M 237.5,237.5 C 239.473,242.4 241.473,247.4 243.5,252.5C 239.893,253.489 236.226,253.823 232.5,253.5C 234.167,248.167 235.833,242.833 237.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#474fba",
    d: "M 249.5,229.5 C 259.833,229.5 270.167,229.5 280.5,229.5C 280.5,231.5 280.5,233.5 280.5,235.5C 276.5,235.5 272.5,235.5 268.5,235.5C 268.5,246.5 268.5,257.5 268.5,268.5C 266.167,268.5 263.833,268.5 261.5,268.5C 261.5,257.5 261.5,246.5 261.5,235.5C 257.5,235.5 253.5,235.5 249.5,235.5C 249.5,233.5 249.5,231.5 249.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#4750b9",
    d: "M 288.5,229.5 C 291.247,229.187 293.914,229.52 296.5,230.5C 301.696,242.753 306.696,255.087 311.5,267.5C 309.235,268.647 306.902,268.814 304.5,268C 302.695,265.433 301.362,262.599 300.5,259.5C 295.208,258.505 289.875,258.172 284.5,258.5C 283.848,261.968 282.515,265.135 280.5,268C 278.098,268.814 275.765,268.647 273.5,267.5C 278.898,254.968 283.898,242.301 288.5,229.5 Z M 291.5,239.5 C 292.376,239.369 293.043,239.702 293.5,240.5C 295.269,244.644 296.936,248.81 298.5,253C 294.5,253.667 290.5,253.667 286.5,253C 288.664,248.674 290.331,244.174 291.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f5cba",
    d: "M 144.5,209.5 C 152.665,214.523 157.498,221.856 159,231.5C 168.664,240.199 172.497,250.866 170.5,263.5C 165.202,258.703 160.035,253.703 155,248.5C 154.667,249.167 154.333,249.833 154,250.5C 148.965,245.297 143.798,240.297 138.5,235.5C 141.004,231.269 141.004,226.936 138.5,222.5C 141.29,222.949 143.956,222.949 146.5,222.5C 143.356,218.012 139.356,214.679 134.5,212.5C 136.216,212.629 137.883,212.962 139.5,213.5C 144.518,216.188 148.185,220.188 150.5,225.5C 152.258,226.128 153.758,227.128 155,228.5C 155.036,224.935 154.036,221.602 152,218.5C 149.665,215.335 147.165,212.335 144.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b4dba",
    d: "M 133.5,229.5 C 132.837,234.271 130.003,236.605 125,236.5C 120.649,236.58 117.816,234.58 116.5,230.5C 121.815,223.081 127.481,222.748 133.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#2e8df0",
    d: "M 320.5,231.5 C 326.593,231.139 332.593,231.639 338.5,233C 345.355,239.689 345.022,246.023 337.5,252C 332.915,253.225 328.248,253.725 323.5,253.5C 323.5,258.167 323.5,262.833 323.5,267.5C 322.5,267.5 321.5,267.5 320.5,267.5C 320.5,255.5 320.5,243.5 320.5,231.5 Z M 323.5,233.5 C 327.915,233.305 332.249,233.805 336.5,235C 341.833,239.667 341.833,244.333 336.5,249C 332.3,250.367 327.967,250.867 323.5,250.5C 323.5,244.833 323.5,239.167 323.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#2e8ef0",
    d: "M 347.5,231.5 C 348.5,231.5 349.5,231.5 350.5,231.5C 350.5,242.833 350.5,254.167 350.5,265.5C 356.206,265.171 361.872,265.505 367.5,266.5C 360.866,267.497 354.2,267.83 347.5,267.5C 347.5,255.5 347.5,243.5 347.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#2d8def",
    d: "M 370.5,231.5 C 371.5,231.5 372.5,231.5 373.5,231.5C 373.334,240.506 373.5,249.506 374,258.5C 378.175,265.869 384.008,267.369 391.5,263C 392.46,261.581 393.293,260.081 394,258.5C 394.5,249.506 394.666,240.506 394.5,231.5C 395.5,231.5 396.5,231.5 397.5,231.5C 397.666,240.839 397.5,250.173 397,259.5C 392.017,268.492 384.85,270.659 375.5,266C 373.383,264.269 371.883,262.102 371,259.5C 370.5,250.173 370.334,240.839 370.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.91
    },
    fill: "#2e8def",
    d: "M 408.5,231.5 C 412.182,231.335 415.848,231.501 419.5,232C 421.116,232.615 422.449,233.615 423.5,235C 423,235.5 422.5,236 422,236.5C 418.577,233.82 414.744,232.987 410.5,234C 406.876,236.161 405.709,239.328 407,243.5C 411.651,246.112 416.485,248.445 421.5,250.5C 426.465,258.101 424.799,263.934 416.5,268C 410.54,269.4 405.54,267.9 401.5,263.5C 403.919,262.105 405.919,262.605 407.5,265C 410.833,265.667 414.167,265.667 417.5,265C 421.791,261.552 422.458,257.552 419.5,253C 415.107,251.318 410.773,249.484 406.5,247.5C 402.088,241.464 402.754,236.131 408.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#5c3ac8",
    d: "M 112.5,255.5 C 109.204,251.702 105.704,248.036 102,244.5C 100.45,245.591 99.2832,246.924 98.5,248.5C 98.5,247.833 98.5,247.167 98.5,246.5C 98.5,245.833 98.5,245.167 98.5,244.5C 102.038,239.776 105.871,235.109 110,230.5C 111.201,233.71 113.201,236.377 116,238.5C 117.315,244.794 116.148,250.461 112.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#394eb9",
    d: "M 138.5,235.5 C 143.798,240.297 148.965,245.297 154,250.5C 154.333,249.833 154.667,249.167 155,248.5C 160.035,253.703 165.202,258.703 170.5,263.5C 170.511,269.151 168.844,274.151 165.5,278.5C 165.631,277.761 165.464,277.094 165,276.5C 155.088,266.48 144.921,256.813 134.5,247.5C 133.2,244.976 133.2,242.309 134.5,239.5C 136.188,238.479 137.521,237.145 138.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#4f82eb",
    d: "M 97.5,229.5 C 97.3375,234.547 97.6708,239.547 98.5,244.5C 98.5,245.167 98.5,245.833 98.5,246.5C 96.9261,244.898 96.2594,242.898 96.5,240.5C 96.185,236.629 96.5184,232.962 97.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#7829d3",
    d: "M 112.5,255.5 C 109.71,263.08 106.377,270.414 102.5,277.5C 100.329,274.495 98.829,271.161 98,267.5C 97.2489,261.116 97.4156,254.783 98.5,248.5C 99.2832,246.924 100.45,245.591 102,244.5C 105.704,248.036 109.204,251.702 112.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4845c0",
    d: "M 134.5,247.5 C 144.921,256.813 155.088,266.48 165,276.5C 165.464,277.094 165.631,277.761 165.5,278.5C 162.724,283.614 158.724,287.281 153.5,289.5C 147.173,275.511 140.839,261.511 134.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#5b39c6",
    d: "M 133.5,263.5 C 128.398,264.121 123.398,264.787 118.5,265.5C 117.427,264.749 117.26,263.749 118,262.5C 119.964,257.899 122.631,253.899 126,250.5C 129.126,254.462 131.626,258.796 133.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e3775",
    d: "M 133.5,263.5 C 128.944,265.442 123.944,266.108 118.5,265.5C 123.398,264.787 128.398,264.121 133.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#752ad2",
    d: "M 140.5,279.5 C 131.244,280.638 121.911,280.805 112.5,280C 111.956,279.283 111.289,278.783 110.5,278.5C 111.487,276.527 112.487,274.527 113.5,272.5C 121.479,271.335 129.479,271.168 137.5,272C 138.781,274.427 139.781,276.927 140.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4750ba",
    d: "M 188.5,276.5 C 189.787,277.871 190.453,279.705 190.5,282C 190.167,283.833 189.833,285.667 189.5,287.5C 188.511,283.893 188.177,280.226 188.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.306
    },
    fill: "#4751ba",
    d: "M 262.5,276.5 C 263.787,277.871 264.453,279.705 264.5,282C 264.167,283.833 263.833,285.667 263.5,287.5C 262.511,283.893 262.177,280.226 262.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#474fb9",
    d: "M 284.5,276.5 C 292.168,276.507 294.168,279.84 290.5,286.5C 283.072,288.704 280.238,286.037 282,278.5C 282.995,277.934 283.828,277.267 284.5,276.5 Z M 284.5,278.5 C 290.148,278.311 291.482,280.478 288.5,285C 287.101,285.595 285.768,285.428 284.5,284.5C 283.306,282.484 283.306,280.484 284.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#474fbb",
    d: "M 318.5,276.5 C 319.239,276.369 319.906,276.536 320.5,277C 321.956,278.745 323.289,280.578 324.5,282.5C 326.177,280.46 327.844,278.46 329.5,276.5C 330.833,280.167 330.833,283.833 329.5,287.5C 328.692,285.577 328.192,283.577 328,281.5C 327.028,283.305 325.861,284.972 324.5,286.5C 323.333,284.833 322.167,283.167 321,281.5C 320.808,283.577 320.308,285.577 319.5,287.5C 318.511,283.893 318.177,280.226 318.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4344cb",
    d: "M 333.5,276.5 C 334.675,276.281 335.675,276.614 336.5,277.5C 334.948,278.798 333.948,278.465 333.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.833
    },
    fill: "#4950b8",
    d: "M 344.5,276.5 C 346.414,279.684 347.08,283.351 346.5,287.5C 340.479,288.427 338.479,286.094 340.5,280.5C 341.689,279.571 343.022,279.238 344.5,279.5C 344.5,278.5 344.5,277.5 344.5,276.5 Z M 341.5,281.5 C 342.5,281.5 343.5,281.5 344.5,281.5C 344.5,282.833 344.5,284.167 344.5,285.5C 343.5,285.5 342.5,285.5 341.5,285.5C 341.5,284.167 341.5,282.833 341.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.758
    },
    fill: "#4750b9",
    d: "M 354.5,276.5 C 355.5,276.5 356.5,276.5 357.5,276.5C 357.823,280.226 357.489,283.893 356.5,287.5C 354.979,287.12 353.313,286.954 351.5,287C 348.332,282.839 349.332,280.339 354.5,279.5C 354.5,278.5 354.5,277.5 354.5,276.5 Z M 352.5,281.5 C 353.586,281.62 354.253,282.287 354.5,283.5C 353.696,285.957 352.696,285.957 351.5,283.5C 351.863,282.817 352.196,282.15 352.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4750ba",
    d: "M 360.5,276.5 C 361.787,277.871 362.453,279.705 362.5,282C 362.167,283.833 361.833,285.667 361.5,287.5C 360.511,283.893 360.177,280.226 360.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.826
    },
    fill: "#474fb9",
    d: "M 381.5,276.5 C 384.764,277.927 387.264,280.261 389,283.5C 389.186,281.1 389.686,278.766 390.5,276.5C 392.973,288.805 390.807,290.138 384,280.5C 383.814,282.9 383.314,285.234 382.5,287.5C 381.511,283.893 381.177,280.226 381.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.757
    },
    fill: "#464fb9",
    d: "M 205.5,277.5 C 206.66,278.611 207.993,279.611 209.5,280.5C 208.675,281.386 207.675,281.719 206.5,281.5C 206.328,283.492 206.995,285.158 208.5,286.5C 208,286.833 207.5,287.167 207,287.5C 205.096,285.61 203.93,283.276 203.5,280.5C 204.612,279.735 205.279,278.735 205.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.845
    },
    fill: "#464fb9",
    d: "M 249.5,277.5 C 253.387,278.657 254.054,280.657 251.5,283.5C 251.919,284.672 252.585,285.672 253.5,286.5C 252.349,287.731 251.183,287.731 250,286.5C 248.937,283.432 248.77,280.432 249.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.861
    },
    fill: "#4750b9",
    d: "M 194.5,279.5 C 201.232,278.482 203.232,281.148 200.5,287.5C 199.534,285.604 199.201,283.604 199.5,281.5C 198.5,281.5 197.5,281.5 196.5,281.5C 196.799,283.604 196.466,285.604 195.5,287.5C 194.52,284.914 194.187,282.247 194.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#464fb9",
    d: "M 212.5,279.5 C 216.241,278.599 218.241,279.932 218.5,283.5C 211.864,284.022 211.864,284.855 218.5,286C 216.667,287.788 214.667,287.954 212.5,286.5C 211.286,284.141 211.286,281.808 212.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#4850ba",
    d: "M 221.5,279.5 C 223.288,279.215 224.955,279.548 226.5,280.5C 225.675,281.386 224.675,281.719 223.5,281.5C 223.799,283.604 223.466,285.604 222.5,287.5C 221.52,284.914 221.187,282.247 221.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#4453bb",
    d: "M 228.5,279.5 C 230.669,280.082 233.002,280.082 235.5,279.5C 235.813,282.247 235.48,284.914 234.5,287.5C 232.886,279.602 231.886,279.602 231.5,287.5C 230.5,287.5 229.5,287.5 228.5,287.5C 228.5,284.833 228.5,282.167 228.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.881
    },
    fill: "#464fb9",
    d: "M 240.5,279.5 C 243.55,278.923 245.55,280.09 246.5,283C 239.206,283.213 238.872,284.213 245.5,286C 243.191,288.051 241.024,287.884 239,285.5C 238.252,283.16 238.752,281.16 240.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.833
    },
    fill: "#474fb8",
    d: "M 268.5,279.5 C 274.176,279.947 274.509,280.781 269.5,282C 271.223,282.523 272.556,283.523 273.5,285C 271.954,287.386 269.954,287.886 267.5,286.5C 268.989,286.467 270.322,285.967 271.5,285C 268.095,284.247 267.095,282.414 268.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#4650b9",
    d: "M 295.5,279.5 C 297.308,280.918 297.975,282.918 297.5,285.5C 298.5,285.5 299.5,285.5 300.5,285.5C 300.201,283.396 300.534,281.396 301.5,279.5C 302.833,282.167 302.833,284.833 301.5,287.5C 299.722,287.431 297.889,287.097 296,286.5C 295.503,284.19 295.337,281.857 295.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#464fb9",
    d: "M 305.5,279.5 C 307.225,280.278 308.891,280.611 310.5,280.5C 308.205,282.2 306.872,284.534 306.5,287.5C 305.52,284.914 305.187,282.247 305.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#4750ba",
    d: "M 334.5,279.5 C 335.748,280.334 336.415,281.667 336.5,283.5C 336.167,284.833 335.833,286.167 335.5,287.5C 334.52,284.914 334.187,282.247 334.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.889
    },
    fill: "#464ebb",
    d: "M 366.5,279.5 C 370.241,278.599 372.241,279.932 372.5,283.5C 365.864,284.022 365.864,284.855 372.5,286C 366.419,288.083 364.419,285.916 366.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#464fb9",
    d: "M 395.5,279.5 C 397.144,279.286 398.644,279.62 400,280.5C 400.497,282.81 400.663,285.143 400.5,287.5C 392.324,287.675 391.658,285.841 398.5,282C 397.167,281.667 395.833,281.333 394.5,281C 395.056,280.617 395.389,280.117 395.5,279.5 Z M 395.5,285.5 C 396.251,284.427 397.251,284.26 398.5,285C 397.648,286.728 396.648,286.895 395.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.903
    },
    fill: "#4650b9",
    d: "M 403.5,279.5 C 407.199,279.625 410.865,279.958 414.5,280.5C 415.724,282.839 415.724,285.172 414.5,287.5C 413.534,285.604 413.201,283.604 413.5,281.5C 412.5,281.5 411.5,281.5 410.5,281.5C 410.114,289.398 409.114,289.398 407.5,281.5C 406.534,283.396 406.201,285.396 406.5,287.5C 405.5,287.5 404.5,287.5 403.5,287.5C 403.5,284.833 403.5,282.167 403.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.834
    },
    fill: "#464ebb",
    d: "M 419.5,279.5 C 422.288,279.077 424.288,280.077 425.5,282.5C 417.646,283.487 417.646,284.654 425.5,286C 421.778,288.49 419.111,287.657 417.5,283.5C 418.18,282.14 418.847,280.807 419.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#303677",
    d: "M 110.5,278.5 C 111.289,278.783 111.956,279.283 112.5,280C 121.911,280.805 131.244,280.638 140.5,279.5C 136.049,280.827 131.216,281.494 126,281.5C 121.167,281.333 116.333,281.167 111.5,281C 110.748,280.329 110.414,279.496 110.5,278.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataplus);
export default __webpack_public_path__ + "static/media/Dataplus.4fcb2f9e325965dc4f894a17fe6b1285.svg";
export { ForwardRef as ReactComponent };